<template>
  <section class="pdf-add-wrapper">
    <b-row
      class="pdf-add-row"
      v-for="(page, pageIndex) in pages"
      :key="'page' + pageIndex"
      style="margin-bottom: 0; padding-bottom: 0"
    >
      <!-- Col: Left (Receipt Container) -->
      <b-col
        class="pdf-add"
        cols="12"
        style="margin-bottom: 0; padding-bottom: 0"
      >
        <b-card
          no-body
          class="pdf-preview-card"
        >
          <!-- Header -->
          <div
            class="pdf_header pdf-padding pt-2"
            style="margin-bottom: 0; padding-bottom: 0"
          >
            <div class="logo">
              <!-- src="@/assets/images/logo.png" -->
              <img class="d-block mx-auto" :src="info.logo_url" />
              <h2 class="mx-auto d-table mt-1">收據 Receipt</h2>
            </div>

            <div class="license color0">
              <div class="license-content" v-html="info.company_info"></div>
              <!-- <div>屋宇署註冊小型工程承建商</div>
              <div>MWC3649/2011</div>
              <div>機電工程署電業承辦商</div>
              <div>026812</div> -->
            </div>
            <div class="pdf-form">
              <b-row class="form-item">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title"> 客戶： </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.name_cn }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col clas="right" cols="5">
                  <b-row>
                    <b-col cols="5" class="text-right title">
                      收據編號：
                    </b-col>
                    <b-col cols="7" class="text">
                      <div class="form-value pdf-number colorRed">
                        {{ pdfData.receipt_number }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="form-item">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title">
                      工程地址：
                    </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.address }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col clas="right" cols="5">
                  <b-row>
                    <b-col cols="5" class="text-right title">
                      發單日期：
                    </b-col>
                    <b-col cols="7" class="text">
                      <div class="form-value">
                        {{ pdfData.receipt_date }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="form-item mb-1">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title">
                      聯絡電話：
                    </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.mobile }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <!-- Spacer -->
          <div
            class="pdf-padding form-item-section"
            style="padding-top: 0; padding-bottom: 0; margin-bottom: 0"
          >
          <!-- :style="{ height: controlValue.minHeight + 'cm' }" -->
            <div
              class="pdf-table receipt"
              style="height: 580px;"
            >
              <div class="line a"></div>
              <div class="line b"></div>
              <div class="line c"></div>
              <div class="line d"></div>
              <div class="d-flex">
                <div class="thead-label">收款日期<br>Date</div>
                <div class="thead-label">發票編號<br>Invoice No.</div>
                <div class="thead-label">支付項目<br>Description</div>
                <div class="thead-label">付款方法<br>Payment Method</div>
                <div class="thead-label">已付金額<br>Amount(HK$)</div>
              </div>

              <div
                v-for="(item, index) in page"
                :key="index"
                ref="row"
                class="d-flex pdf-item"
              >
              <div class="pdf-item-text-wrapper">
                  <span class="pdf-item-text">{{ item.payment_date }}</span>
              </div>
                <div class="pdf-item-text-wrapper">
                  <span class="pdf-item-text colorRed">{{ item.invoice && item.invoice.invoice_number }}</span>
                </div>
                
                <div class="pdf-item-text-wrapper">
                  <span 
                    class="pdf-item-text"
                    v-html="changeNextLine(  item.payment_step ? 
                  `${item.payment_step.step_phase}${item.payment_step.step_name ? `：${item.payment_step.step_name}` : ''} ${item.payment_step.step_percentage}%（$${item.payment_step.step_amount}）`
                  : item.item_description )"
                  ></span>
                </div>
                
                <div class="pdf-item-text-wrapper">
                  <span
                    class="pdf-item-text"
                  > {{ paymentMethodOptions && paymentMethodOptions.find(ele => ele.id == item.payment_method_id) ? paymentMethodOptions.find(ele => ele.id == item.payment_method_id).name : '' }}
                  <template v-if="item.payment_method_id == 1 && item.check_number">
                    <br>{{ item.check_number }}
                  </template>
                  </span>
                </div>
                <div class="pdf-item-text-wrapper amount-column">
                  <div class="amount-content w-100" v-if="!item.is_remark">
                    <template v-if="item.is_reprint">
                      <small class="colorRed reference-receipt">{{ getReferenceReceiptNumber(item) }}</small>
                      <div class="actual-amount">HK${{ formatMoney(getOriginalAmount(item)) }}</div>
                    </template>
                    <template v-else>
                      <div class="normal-amount">HK${{ formatMoney(item.amount || 0) }}</div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex mt-1 justify-content-between">
              <div class="d-block text-left col-6">
                <div class="d-flex">
                  <span class="mr-1">付款方法:</span
                  ><span>{{
                    pdfData.payment_method && pdfData.payment_method.name
                  }}</span>
                </div>
                <!-- <div class="d-flex" v-if="pdfData.payment_method_id == 1">
                  <span class="mr-1">支票號碼:</span
                  ><span>{{ pdfData.check_number }}</span>
                </div> -->
              </div>
              <div
                class="pdf-table-amount receipt"
                :class="{ 'not-finish': pageIndex < pages.length - 1 }"
              >
                <div></div>
                <span
                  v-if="pageIndex == pages.length - 1"
                  class="total-amount"
                  >{{ getNumberFormat(getTotalAmount()) }}</span
                >
                <span v-else class="total-amount">轉下頁</span>

                <img
                  v-if="info.stamp_url"
                  class="stamp_logo"
                  :src="info.stamp_url"
                  alt=""
                />
                <!-- src="@/assets/images/logo/image(1).png" -->

                <!-- :src="info.stamp_url" -->
              </div>
            </div>
          </div>
          <!-- Footer & Payment Detail -->
          <div class="pdf-padding">
            <div class="pdf-form sign">
              <div class="my-2 text-left remark">
                <label class="" v-if="pdfData.receipt_remark"
                  >備 註 Remarks:</label
                >
                <div
                  class="text-12"
                  v-html="changeNextLine(pdfData.receipt_remark)"
                />

                <!-- <ol class="pl-2">
                  <li>
                    交來票據兌現作實。Cheques are not recognised until bank
                    clearance.
                  </li>
                  <li>
                    This document is generated by computer and is genuine true
                    copy duly authorised by us. No manual signature will be
                    added unless request.此乃電腦列印文件，無須簽署。
                  </li>
                  <li>
                    All prices listed above is in Hong Kong Dollar (HKD)) unless
                    specified. 所有金額均為港元。
                  </li>
                </ol> -->
              </div>
              <hr class="w-100" />
              <div class="d-flex company-info flex-wrap mb-0">
                <div class="w-50">
                  <div class="d-flex">
                    <span>地址：</span>
                    <span>{{ info.address }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>網址：</span>
                    <span>{{ info.website }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>電話：</span>
                    <span>{{ info.phone }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>電郵：</span>
                    <span>{{ info.email }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>傳真：</span>
                    <span>{{ info.fax }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div> 
          <div class="pdf-bottom">
            {{ `P.${pageIndex+1}/${pages.length}` }}
            </div>
        </b-card>
      </b-col>
      <!-- <b-col cols="12">
        <NoticeToCustomers />
      </b-col> -->
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardText } from "bootstrap-vue";
import store from "@/store";

import { mapFields } from "vuex-map-fields";
import { ref, watch, computed, onMounted } from "@vue/composition-api";
import { formatMoney } from "@/libs/helper.js";
import NoticeToCustomers from "@/views/invoice/invoices-preview/NoticeToCustomers.vue";
import { buildPages, measureRowHeight } from "@/libs/pdf-pagination";

// 收據表格的排版尺寸。欄寬喺 scoped style 用百分比，表格內容闊度 671px（793px 版面扣兩邊 60.48px padding 及 1px 邊框）。
// 表頭係兩行（中英對照），所以可用高度比發票細。
const TABLE_BODY_HEIGHT = 515; // 表格 580px 扣邊框及兩行表頭（約 58.5px）
const DATE_WIDTH = 100; // 收款日期 15%
const INVOICE_NO_WIDTH = 120; // 發票編號 18%，padding-left 0
const DESCRIPTION_WIDTH = 196; // 支付項目 30% 扣 5px padding-left
const PAYMENT_METHOD_WIDTH = 131; // 付款方法 20% 扣 3px padding-right
const AMOUNT_WIDTH = 114; // 已付金額 17%

export default {
  data() {
    return {
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      pages: [],
    };
  },
  methods: {
    formatMoney,
    // 獲取原始金額（用於重印項目顯示）
    getOriginalAmount(item) {
      if (!item || !item.is_reprint) return 0;

      // 優先使用後端提供的原始收據金額
      if (item.reference_receipt_amount && typeof item.reference_receipt_amount !== 'undefined') {
        return Number(item.reference_receipt_amount);
      }

      // 如果有 original_amount 欄位，使用它
      if (item.original_amount && typeof item.original_amount !== 'undefined') {
        return Number(item.original_amount);
      }

      // 從 payment_step.step_amount 取得（作為備用）
      if (item.payment_step && typeof item.payment_step.step_amount !== 'undefined') {
        return Number(item.payment_step.step_amount);
      }

      // 如果沒有 payment_step 但有 payment_step_id，嘗試從發票的 paymentSteps 中查找
      if (item.payment_step_id && item.invoice && item.invoice.paymentSteps) {
        const paymentStep = item.invoice.paymentSteps.find(step => step.id === item.payment_step_id);
        if (paymentStep && typeof paymentStep.step_amount !== 'undefined') {
          return Number(paymentStep.step_amount);
        }
      }

      // 預設返回 0
      return 0;
    },

    // 獲取參考收據編號
    getReferenceReceiptNumber(item) {
      if (!item || !item.is_reprint) return '';

      // 優先使用後端提供的參考收據編號
      if (item.reference_receipt_number) {
        return `重印: ${item.reference_receipt_number}`;
      }

      // 如果有 payment_step 中的參考收據編號
      if (item.payment_step && item.payment_step.previous_receipt_number) {
        return `重印: ${item.payment_step.previous_receipt_number}`;
      }

      // 如果是重印項目但沒有參考編號，嘗試構造一個合理的參考編號
      if (item.invoice && item.invoice.invoice_number) {
        return `重印: ${item.invoice.invoice_number} 階段付款`;
      }

      // 預設顯示
      return '重印: Re-Print';
    },

    changeDate(dateToChange) {
      var newDate = new Date(dateToChange);
      newDate.toLocaleString("default", { month: "long" });
      return (
        newDate.getDate() +
        " " +
        this.month[newDate.getMonth()] +
        " " +
        newDate.getFullYear()
      );
    },
    getNumberFormat(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HKD",
        minimumFractionDigits: 2, // 確保總是顯示2位小數
        maximumFractionDigits: 2, // 限制最多2位小數
      });
      return formatter.format(amount);
    },
    changeNextLine(str) {
      // 處理不同的資料類型
      if (!str) {
        return "";
      }

      // 如果是字串，直接處理
      if (typeof str === 'string') {
        return str.replace(/\n/g, "<br>");
      }

      // 如果是物件且有 content 屬性（例如備註物件）
      if (typeof str === 'object' && str.content) {
        return typeof str.content === 'string' ? str.content.replace(/\n/g, "<br>") : "";
      }

      // 如果是物件且有 title 屬性
      if (typeof str === 'object' && str.title) {
        return typeof str.title === 'string' ? str.title.replace(/\n/g, "<br>") : "";
      }

      // 如果是數字或其他原始類型，轉換為字串
      if (typeof str === 'number' || typeof str === 'boolean') {
        return String(str);
      }

      // 如果是陣列，嘗試連接元素
      if (Array.isArray(str)) {
        return str.map(item =>
          typeof item === 'string' ? item :
          (typeof item === 'object' && item.content) ? item.content :
          String(item)
        ).join('<br>');
      }

      // 其他情況，嘗試轉換為字串
      try {
        const stringValue = String(str);
        return stringValue !== '[object Object]' ? stringValue : "";
      } catch (error) {
        console.warn('changeNextLine: 無法處理的資料類型', str);
        return "";
      }
    },
    getTotalAmount() {
      var totalAmount = 0;
      if (this.pdfData.receipt_items) {
        this.pdfData.receipt_items.forEach((item) => {
          totalAmount += item.amount;
        });
      }
      return totalAmount;
    },
    splitIntoPages() {
      if (
        !this.pdfData.receipt_items ||
        this.pdfData.receipt_items.length === 0
      ) {
        return;
      }

      const rows = this.pdfData.receipt_items.map((item, index) => ({
        ...item,
        count: index + 1,
      }));

      if (this.pdfData.remark) {
        rows.push(this.buildRemarkRow(this.pdfData.remark));
      }

      this.pages = buildPages({
        rows,
        bodyHeight: TABLE_BODY_HEIGHT,
        descriptionWidth: DESCRIPTION_WIDTH,
        measureRow: this.measureRow,
        getDescription: (row) => this.toPlainText(this.getDescriptionHtml(row)),
        withDescription: (row, text, index) =>
          index === 0
            ? { ...row, payment_step: null, item_description: text }
            : { ...row, ...this.buildRemarkRow(text) },
      });

      // 触发更新
      this.$forceUpdate();
    },

    buildRemarkRow(description) {
      return {
        is_remark: true,
        id: null,
        item_description: description,
        payment_date: null,
        invoice: null,
        payment_step: null,
        payment_method_id: null,
        check_number: null,
        is_reprint: false,
        amount: null,
      };
    },

    // .pdf-item 係 flex 列，高度由最高嗰個欄位決定，唔可以淨係計支付項目欄。
    measureRow(row) {
      const cells = [
        { html: row.payment_date, width: DATE_WIDTH },
        {
          html: row.invoice && row.invoice.invoice_number,
          width: INVOICE_NO_WIDTH,
        },
        { html: this.getDescriptionHtml(row), width: DESCRIPTION_WIDTH },
        { html: this.getPaymentMethodHtml(row), width: PAYMENT_METHOD_WIDTH },
      ];

      if (!row.is_remark) {
        cells.push({ html: this.getAmountHtml(row), width: AMOUNT_WIDTH });
      }

      return measureRowHeight(cells);
    },

    getDescriptionHtml(row) {
      return this.changeNextLine(
        row.payment_step
          ? `${row.payment_step.step_phase}${
              row.payment_step.step_name
                ? `：${row.payment_step.step_name}`
                : ""
            } ${row.payment_step.step_percentage}%（$${
              row.payment_step.step_amount
            }）`
          : row.item_description
      );
    },

    getPaymentMethodHtml(row) {
      const option =
        this.paymentMethodOptions &&
        this.paymentMethodOptions.find((ele) => ele.id == row.payment_method_id);
      const checkNumber =
        row.payment_method_id == 1 && row.check_number
          ? `<br>${row.check_number}`
          : "";

      return `${option ? option.name : ""}${checkNumber}`;
    },

    // 重印列會多一行參考收據編號，字級同行高同正常金額唔一樣，要照原樣量度。
    getAmountHtml(row) {
      if (row.is_reprint) {
        return `<small style="display: block; font-size: 11px; line-height: 1.2; margin-bottom: 2px">${this.getReferenceReceiptNumber(
          row
        )}</small><div style="font-size: 14px; line-height: 1.2">HK$${this.formatMoney(
          this.getOriginalAmount(row)
        )}</div>`;
      }

      return `<div style="font-size: 14px; line-height: 1.2">HK$${this.formatMoney(
        row.amount || 0
      )}</div>`;
    },

    // changeNextLine 已處理各種資料型別，呢度只係反轉返 <br> 做純文字方便切割。
    toPlainText(description) {
      const html = this.changeNextLine(description);
      return html ? html.replace(/<br\s*\/?>/gi, "\n") : "";
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    NoticeToCustomers,
  },
  props: {
    pdfData: {
      type: Object,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
    paymentMethodOptions: {
      type: Array,
      required: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  watch: {
    "pdfData.receipt_items": {
      handler() {
        this.splitIntoPages();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapFields(["controlValue"]),
  },
  setup(props) {
    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
      company_info: null,
      logo_url: null,
    });

    const getInfo = (template_id, stamp_id) => {
      let template =
        props.templateOptions &&
        props.templateOptions.find((ele) => ele.id == template_id);

      let stamp =
        props.stampOptions &&
        props.stampOptions.find((ele) => ele.id == stamp_id);

      if (template) {
        info.value.website = template.website || '';
        info.value.address = template.address || '';
        info.value.phone = template.phone || '';
        info.value.fax = template.fax || '';
        info.value.email = template.email || '';
        info.value.company_info = template.company_info || '';
        info.value.bank_info = template.bank_info || '';
        info.value.logo_url = template.logo_url || '';
        info.value.stamp_url = stamp ? stamp.image_url || '' : '';
      }
    };

    // 監聽 pdfData 變化
    watch(
      () => props.pdfData,
      (newVal) => {
        if (newVal && newVal.template_id) {
          getInfo(newVal.template_id, newVal.stamp_id);
        }
      },
      { immediate: true }
    );

    // 監聽 templateOptions 變化
    watch(
      () => props.templateOptions,
      (newVal) => {
        if (newVal && newVal.length > 0 && props.pdfData && props.pdfData.template_id) {
          getInfo(props.pdfData.template_id, props.pdfData.stamp_id);
        }
      },
      { immediate: true }
    );

    return {
      info,
      getInfo
    };
  },
};
</script>

<style lang="scss" scoped>

.stamp_logo{
  // margin-left:-20px;
  top:-30px;
  right:100px!important;
}
// .pdf-add-wrapper .company-info *{
//   font-size:14px;
// }
.remark{
  height:90px;
  pre{
      font-size: 14px;
  }
}

// 調整表格佈局，移除重印欄後重新分配寬度
.pdf-table.receipt {
  .d-flex {
    .thead-label {
      &:nth-child(1) { width: 15%; } // 收款日期
      &:nth-child(2) { width: 18%; } // 發票編號
      &:nth-child(3) { width: 30%; } // 支付項目
      &:nth-child(4) { width: 20%; } // 付款方法
      &:nth-child(5) { width: 17%; } // 金額 (增加寬度以容納參考收據編號)
    }
  }

  .pdf-item {
    .pdf-item-text-wrapper {
      &:nth-child(1) { width: 15%; } // 收款日期
      &:nth-child(2) { width: 18%; } // 發票編號
      &:nth-child(3) { width: 30%; } // 支付項目
      &:nth-child(4) { width: 20%; } // 付款方法
      &:nth-child(5) { width: 17%; } // 金額欄
    }

    // 金額欄位特殊樣式
    .amount-column {
      .amount-content {
        text-align: center;

        .reference-receipt {
          display: block;
          font-size: 11px;
          line-height: 1.2;
          margin-bottom: 2px;
          color: #dc3545;
        }

        .actual-amount {
          font-size: 14px;
          font-weight: normal;
          line-height: 1.2;
        }

        .normal-amount {
          font-size: 14px;
          font-weight: normal;
          text-align: center;
        }
      }
    }
  }
}

// 調整表格線條位置（移除一條線）
.pdf-table.receipt {
  .line {
    &.a { left: 15%; }  // 第一條線
    &.b { left: 33%; }  // 第二條線
    &.c { left: 63%; }  // 第三條線
    &.d { left: 83%; }  // 第四條線
    // 移除第五條線 (原本的 line e)
  }
}

// pdf
</style>